import { get, post, postForm } from '@/utils/request'

const fileApi = {
  ossServerApi: '/api/file/oss/serverinfo',
  ossUploadApi: '/api/file/oss',
  fileUploadApi: '/api/file/upload',
  aliyunOssApi: '/api/file/aliyun'
}

export function getImageChannelInfo() {
  return post(fileApi.ossServerApi + '/image')
}

export function getPhotoChannelInfo() {
  return post(fileApi.ossServerApi + '/photo')
}

export function getVideoChannelInfo() {
  return post(fileApi.ossServerApi + '/video')
}

export function prepareUpload(payload) {
  return post(fileApi.ossUploadApi + '/prepare_upload', payload)
}

export function checkSample(payload) {
  return post(fileApi.ossUploadApi + '/check_sample', payload)
}

export function uploadFile(payload) {
  return postForm(fileApi.fileUploadApi, payload)
}

export function getAliyunOssSignature() {
  return get(fileApi.aliyunOssApi + '/signature')
}

export function addUploadedObject(payload) {
  return post(fileApi.aliyunOssApi + '/uploaded', payload)
}

export function getOssSignedUrl(payload) {
  return post(fileApi.aliyunOssApi + '/signed_url', payload)
}
